import React, {Component} from 'react'

import Spinner from './Spinner'
import PropTypes from 'prop-types'
import verifiedIcon from '../../../assets/icons/verified.svg'
import verifiedIconDark from '../../../assets/icons/verified-dark.svg'
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n"
import Text from "../../i18n/Text"
import I18nContext from "../../i18n/I18nContext";

const REDIRECT_TIMEOUT_SECONDS = 5

export default class IdentSuccess extends Component {
    static contextType = I18nContext
    eidIdent

    componentDidMount() {
        this.eidIdent = this.props.caseInfo;
        this.forceUpdate();
    }

    redirect = () => {
        const termination = this.eidIdent.modules.identStatus
        window.location.assign(termination[termination.continueButton.target].webUrl)
    }

    render() {
        if (!this.eidIdent) {
            return <div>
                {/* visually-hidden for a11y */}
                <h1 className="visually-hidden">Loading</h1>
                <Spinner />
            </div>
        }

        const identCallTermination = this.eidIdent.modules.identStatus
        const principalDisplayName = this.eidIdent.principalDisplayName
        const text = identCallTermination.subtitle

        if (hasCallbackUrl(identCallTermination)) {
            setTimeout(this.redirect, REDIRECT_TIMEOUT_SECONDS * 1000)
        }

        return <div className="col d-flex flex-column justify-content-center align-items-center">
            <h1 className="text-center">{text}</h1>
            <div >
                <img src={verifiedIcon} alt="verified" className="dark-img m-4 mw-100"
                     style={{width: '80px'}} data-test-id="34anlfjqvsc4"/>
                <img src={verifiedIconDark} alt="verified" className="light-img m-4 mw-100"
                     style={{width: '80px'}} data-test-id="34anlfjqvsc4"/>
            </div>
            <div className="row">
                <div className="mb-2">
                    <div className="pi-section__content" data-test-id="fb7d4972-d08c">
                        <span className="pi-illustration pi-illustration--sm pi-illustration--success"/>
                        {hasCallbackUrl(identCallTermination)
                            ? <Redirect redirectFn={this.redirect}
                                        buttonText={identCallTermination.continueButton.text}/>
                            : getI18nTextWithContext(this.context, 'common.identPre') + ` ${principalDisplayName} `
                            + getI18nTextWithContext(this.context, 'common.identPost')}
                    </div>
                </div>
            </div>
        </div>
    }
}
IdentSuccess.propTypes = {
    caseId: PropTypes.string.isRequired,
    caseInfo: PropTypes.object.isRequired
}

function Redirect({redirectFn, buttonText}) {
    return <React.Fragment>
        <div className="d-flex flex-column justify-content-center align-items-center">
            <p data-test-id="d40cff5c-faf5">
                <Text k='common.redirectPre'/> <strong>{REDIRECT_TIMEOUT_SECONDS} <Text k='common.seconds'/></strong>
                <Text k='common.redirectPost'/>
            </p>
            <p data-test-id="0c309c3f-cf46"><Text k='startEId.error.redirect'/></p>
            <button data-test-id="a1187592-61a7" onClick={redirectFn} className="btn btn-primary">
                {buttonText}
            </button>
        </div>
    </React.Fragment>
}

Redirect.propTypes = {
    redirectFn: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired
}

function hasCallbackUrl(termination) {
    return termination?.continueButton?.target
        && termination[termination.continueButton.target]?.webUrl
}

